class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this.generateRecommendations();
	}

	async generateRecommendations(){
		const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');
		if ( cartItems.length == 0 ) return;

		// erst die in Search & Discovery gepflegten Komplementaerprodukte,
		// nur wenn dort nichts hinterlegt ist die Shopify-Automatik
		for ( const intent of ['complementary','related'] ) {
			const markup = await this.fetchRecommendations(cartItems[0].dataset.productId, intent);
			if ( markup ) {
				this.innerHTML = markup;
				return;
			}
		}
	}

	fetchRecommendations(productId, intent){
		return fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${productId}&limit=${this.dataset.limit}&intent=${intent}`)
			.then(response => response.text())
			.then(text => {
				const innerHTML = new DOMParser()
					.parseFromString(text, 'text/html')
					.querySelector('[data-js-cart-recommendations-performed]');
				return ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) ? innerHTML.innerHTML : null;
			})
			.catch(() => null)
	}
}
customElements.define('cart-recommendations', CartRecommendations);
